/**
 * Created by comoon on 2/18/16.
 * 行程状态
 * 与后台返回状态同步
 */


var Accept = {
    code: 0,
    real: "达人审核通过",
    text: "审核通过"
};

var Edit = {
    code: 1,
    real: "达人正在修改",
    text: "修改中"
};

var Fail = {
    code: 4,
    real: "达人审核不通过",
    text: "审核不通过"
};

var finish = {
    code: 6,
    real: "完成行程修改",
    text: "提交"
};


module.exports = {
    Accept,
    Edit,
    Fail,
    finish,
    list: [Accept, Edit, Fail, finish]
};


/** WEBPACK FOOTER **
 ** ./script/conf/trip-status.js
 **/